import {useRequest} from '@hooks'
import type { AgendaExternaCadastroRequest, ClienteHttp, FilialDto, Identificador, VolumeDto, XmlNfeResponse } from '../types';

const BASE_URL = '/agenda-externa'

// Instanciado sob demanda (e não no topo do módulo) porque @services e @hooks
// se importam em ciclo (AgendaExternaService -> @hooks -> useRequest -> @services);
// chamar useRequest() na primeira avaliação do módulo pode ocorrer antes do
// ciclo terminar de resolver, com useRequest ainda indefinido.
// TODO: Claude 14/09/2026 | remover a instanciação lazy quando useRequest.ts
// passar a importar getTokenFromKeycloak direto de ./keycloakService em vez do
// barril @services, o que quebra o ciclo de import e permite instanciar no topo do módulo.
let cliente: ClienteHttp | undefined

function obterCliente(): ClienteHttp {
    // useRequest não é um hook React (não usa useState/useContext/etc.), é uma
    // fábrica que só coincide com o prefixo "use". A regra estática não sabe
    // disso e acusa chamada de hook fora de componente/hook.
    // eslint-disable-next-line react-hooks/rules-of-hooks
    cliente ??= useRequest()
    return cliente
}

async function getVolumes(filial: Identificador) {
    return obterCliente().get<VolumeDto[]>(`${BASE_URL}/month`, {filial})
}

async function getTransports(codFornecedor: Identificador) {
    return obterCliente().get<FilialDto[]>(`${BASE_URL}/transport`, {codFornecedor})
}

async function getSupplier() {
    return obterCliente().get<FilialDto[]>(`${BASE_URL}/supplier`)
}

async function getFilial() {
    return obterCliente().get<FilialDto[]>(`${BASE_URL}/filtro/filial`)
}

async function getVolumeByFilial(filial: Identificador) {
    return obterCliente().get<number>(`${BASE_URL}/filtro/volume/${filial}`)
}

async function finalizeScheduling(requestDto: AgendaExternaCadastroRequest) {
    return obterCliente().post<void, AgendaExternaCadastroRequest>(`${BASE_URL}`, requestDto);
}

async function finalizePreScheduling(requestDto: AgendaExternaCadastroRequest) {
    return obterCliente().post<void, AgendaExternaCadastroRequest>(`${BASE_URL}/pre-agenda`, requestDto);
}

async function completePreScheduling(requestDto: AgendaExternaCadastroRequest) {
    return obterCliente().post<void, AgendaExternaCadastroRequest>(`${BASE_URL}/complete-pre-agenda`, requestDto);
}

async function getXmlNfe(chaveAcesso: string) {
    return obterCliente().get<XmlNfeResponse>(`${BASE_URL}/xml-nfe/${chaveAcesso}`);
}

export const agendaExternaService = {
    getVolumes,
    getTransports,
    getSupplier,
    getFilial,
    finalizeScheduling,
    finalizePreScheduling,
    completePreScheduling,
    getVolumeByFilial,
    getXmlNfe,
}

/**
 * Adapter temporário: preserva a factory atual para os consumidores que ainda
 * não migraram para o singleton puro (Tasks 6-8 da Fase 5). Não chama hook React.
 */
export function AgendaExternaService() {
    return agendaExternaService
}
